import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Button } from 'primereact/button';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Language } from '../types';

interface LanguageOption {
  label: string;
  value: Language;
}

function Layout(): React.ReactElement {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { language, changeLanguage } = useLanguage();
  const navigate = useNavigate();

  const languages: LanguageOption[] = [
    { label: 'العربية', value: 'ar' },
    { label: 'English', value: 'en' }
  ];

  const handleLogout = (): void => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="navbar-content">
          <div className="logo">
            <i className="pi pi-book"></i>
            <span>{t('app.name')}</span>
          </div>
          
          <div className="hidden md:flex align-items-center gap-3">
            <NavLink to="/" className={({ isActive }) => 
              `p-button p-button-text ${isActive ? 'p-button-primary' : ''}`
            }>
              {t('nav.dashboard')}
            </NavLink>
            <NavLink to="/profiles" className={({ isActive }) => 
              `p-button p-button-text ${isActive ? 'p-button-primary' : ''}`
            }>
              {t('nav.profiles')}
            </NavLink>
            <NavLink to="/surahs" className={({ isActive }) => 
              `p-button p-button-text ${isActive ? 'p-button-primary' : ''}`
            }>
              {t('nav.surahs')}
            </NavLink>
          </div>

          <div className="flex align-items-center gap-2">
            <Dropdown 
              value={language}
              options={languages}
              onChange={(e: DropdownChangeEvent) => changeLanguage(e.value)}
              style={{ minWidth: '120px' }}
            />
            <NavLink to="/settings">
              <Button icon="pi pi-cog" className="p-button-text p-button-rounded" />
            </NavLink>
            <Button 
              icon="pi pi-sign-out" 
              className="p-button-text p-button-rounded"
              onClick={handleLogout}
              tooltip={t('auth.signOut')}
            />
          </div>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation */}
      <nav className="bottom-nav">
        <NavLink to="/" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <i className="pi pi-home"></i>
          <span>{t('nav.dashboard')}</span>
        </NavLink>
        <NavLink to="/profiles" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <i className="pi pi-users"></i>
          <span>{t('nav.profiles')}</span>
        </NavLink>
        <NavLink to="/surahs" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <i className="pi pi-list"></i>
          <span>{t('nav.surahs')}</span>
        </NavLink>
        <NavLink to="/settings" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <i className="pi pi-cog"></i>
          <span>{t('nav.settings')}</span>
        </NavLink>
      </nav>
    </div>
  );
}

export default Layout;
